import React from 'react';
import { Modal } from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IMAGE_BASE_URL } from "../../config/api";

const ImageSlider = ({ visible, onClose, images }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
    >
      <div className="p-4">
        <Slider {...settings}>
          {images?.map((image, index) => (
            <div key={index} className="outline-none">
              <img
                src={`${IMAGE_BASE_URL}${image.url}`}
                alt={image.original_name}
                className="w-full h-[500px] object-contain mx-auto"
              />
              <p className="text-center mt-2 text-gray-600">
                {image.original_name}
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </Modal>
  );
};

export default ImageSlider; 